import type { PropertyType } from '../filterTypes';

const PROPERTY_TYPE_TO_API = {
  apartment: ['garden', 'large', 'medium'],
  condo: ['condo'],
  house: ['house'],
  townhouse: ['townhouse'],
  duplex: ['divided'],
} satisfies Record<PropertyType, Array<string>>;

/**
 * Maps user-facing property types to internal API types.
 * ['apartment', 'house'] → "garden,large,medium,house"
 * [] → undefined (any type, omit param)
 */
export function mapPropertyTypesToApi(types: Array<PropertyType>): string | undefined {
  if (types.length === 0) return undefined;

  return types
    .flatMap((t) => PROPERTY_TYPE_TO_API[t])
    .sort()
    .join(',');
}
